import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from './auth.service';
import { Translation } from '../../providers/translation';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { filter, tap } from 'rxjs/operators';
import { app_themes } from '../../theme/themes.const';
import { ThemeService } from '../../theme/theme.service';
import { ThemeDirective } from '../../theme/theme.directive';
import * as store from 'store';
import { eva_constants } from '../../eva_constants';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public error: string = '';
  public credentials: { login: string; password: string } = {
    login: '',
    password: ''
  };
  private accountType: 'user' | 'admin' | 'special';
  public logoPath = '';
  public isEva = false;
  public isLivee = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public authService: AuthService,
    private translation: Translation,
    private fb: FormBuilder,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.accountType = 'admin';

    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
        })
      )
      .subscribe(null);
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    let newTheme: any;
    let _logoPath: any;
    if (data.theme) {
      const appTheme = app_themes[data.theme];
      if (appTheme) {
        newTheme = data.theme;
        _logoPath = appTheme[ThemeDirective.LOGIN_LOGO_PATH];
      }
    }
    this.logoPath = _logoPath ? _logoPath : this.logoPath;
    if (newTheme) this.themeService.setActiveTheme(newTheme);
    this.isEva = data.theme === eva_constants.EVA_THEME;
    this.isLivee = data.theme === eva_constants.LIVEE_THEME;
  }

  areEqual(c: AbstractControl) {
    if (c.get('password').value.length < 6) return { length: true };
    if (c.get('password').value !== c.get('repeat').value) {
      return { equal: true };
    }
  }

  login(provider = null) {
    if (provider) {
      return this.authService.redirectToProvider(provider);
    }
    this.authService.login(this.credentials, this.accountType).subscribe(
      success => {
        if (success) {
          this.router.navigate(['/']);
        }
      },
      err => {
        this.error = err;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/login.component.ts